<style lang="scss" scoped>
.order-cards {
    display: flex;
    flex-flow: column;
    @media screen and (max-width: 1279.98px) {
        flex-flow: wrap;
        margin-right: -24px;
    }
}
.order-card {
    display: flex;
    flex-flow: row;
    @media screen and (max-width: 1279.98px) {
        flex-flow: column;
        width: 50%;
    }
    .order-image {
        width: 180px;
        height: 128px;
        margin-right: 24px;
        flex: none;
        @media screen and (max-width: 1279.98px) {
            width: auto;
            height: 240px;
            margin-bottom: 16px;
            margin-right: 24px;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            font-family: "object-fit: cover;";
            border-radius: 4px;
        }
    }
    .order-content {
        width: 100%;
        h3 {
            line-height: 38px;
        }
        .tag-row {
            margin-bottom: -4px;
            .tag {
                margin-bottom: 4px;
            }
        }
        .location,
        .group-size,
        .duration {
            &:before {
                content: "";
                background-size: 12px 12px;
                display: inline-block;
                width: 12px;
                height: 12px;
                margin-right: 8px;
            }
        }
        .location {
            &:before {
                background-image: url("/svg/icon-location.svg");
            }
        }

        .group-size {
            &:before {
                background-image: url("/svg/icon-group-size.svg");
            }
        }

        .duration {
            &:before {
                background-image: url("/svg/icon-clock.svg");
            }
        }
    }
    .order-delete {
        text-align: right;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
}
</style>

<template>
    <div class="order-cards">
        <div class="order-card mb-24" v-for="order in localValue" :key="order.ID">
            <div class="order-image">
                <img :src="order.image.sizes.medium_large" :alt="order.title">
            </div>
            <div class="order-content">
                <h3 v-html="order.title"></h3>
                <div v-if="order.categories && order.categories.length > 0" class="tag-row d-none d-xl-flex mt-16" ref="categories" :key="order.categories.length">
                    <!--<div ref="tags" class="tag-col" v-for="(category, index) in order.categories.filter(cat => cat.parent === 6).slice(0,3)" :key="index">-->
                    <div ref="tags" class="tag-col" v-for="(category, index) in order.categories" :key="index">
                        <div class="tag tag-accent-light tag-xs" v-html="category" />
                    </div>
                </div>
            </div>
            <div v-if="canDelete" class="order-delete xsmall" @click="removeOrder(order.ID)">
                <span class="mr-8 my-auto font-weight-bold">Verwijder</span>
                <span class="my-auto" v-html="svg('trash')"></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "forms.el-orders",

    props: {
        value: {
            type: Array,
            default: () => []
        },
        canDelete: {
            type: Boolean,
            default: true
        }
    },

    data: (vm) => ({
        localValue: vm.value
    }),

    methods: {
        removeOrder(id) {
            this.localValue.splice(this.localValue.findIndex(val => val.ID === id), 1);
            this.update();
        },
        update() {
            this.$emit('input', this.localValue);
        }
    },

    watch: {
        value: function (newValue) {
            this.localValue = newValue
        }
    }
}
</script>